import { render, staticRenderFns } from "./activationRecord.vue?vue&type=template&id=7b47afbf&scoped=true&"
import script from "./activationRecord.vue?vue&type=script&lang=js&"
export * from "./activationRecord.vue?vue&type=script&lang=js&"
import style0 from "./activationRecord.vue?vue&type=style&index=0&id=7b47afbf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b47afbf",
  null
  
)

export default component.exports